const YBUG_ID = '741th6x1kccb4cx36c8k';

// Inject the Ybug loader. Kept fully isolated: any failure here must degrade to "no feedback
// widget", never a thrown error or a half-mounted blocking overlay (EWM-820).
const injectYbugScript = () => {
  try {
    const ybug = document.createElement('script');
    ybug.type = 'text/javascript';
    ybug.async = true;
    ybug.src = `https://widget.ybug.io/button/${YBUG_ID}.js`;
    // Fail silent: a blocked (CSP) or failed widget load must not surface as an app error.
    ybug.onerror = () => {
      // eslint-disable-next-line no-console
      console.warn('[ybug] widget failed to load; feedback disabled for this session');
    };

    const s = document.getElementsByTagName('script')[0];
    if (s?.parentNode) {
      s.parentNode.insertBefore(ybug, s);
    } else {
      document.head.appendChild(ybug);
    }
  } catch (err) {
    // Never let the third-party feedback bootstrap break the app.
    // eslint-disable-next-line no-console
    console.warn('[ybug] init skipped:', err);
  }
};

export const initYbug = () => {
  // The settings object must exist synchronously so updateYbugSettings (auth context) can enrich
  // it with the user/tenant once auth resolves. This is cheap and touches no network.
  window.ybug_settings = {
    id: YBUG_ID,
    user: {
      id: '{{userId}}',
      username: '{{userEmail}}',
    },
  };

  // Defer the actual widget injection until after the app has loaded, so a slow or CSP-blocked
  // third-party load can never delay first paint or interfere with the B2C auth redirect.
  const start = () => window.setTimeout(injectYbugScript, 0);

  if (document.readyState === 'complete') {
    start();
  } else {
    window.addEventListener('load', start, { once: true });
  }
};

// Initialize Ybug when the module is loaded
initYbug();
